import { timediaUrl } from "./config";

export const getKeyValuePublique = (cle, callback) => {
	const tokenPublic = "cHVibGljOjk4SE85SE9JVUdPSTk4SA==";
	const defaultHeaders = {
		Accept: "application/json",
		"Content-Type": "application/json",
		Authorization: "Basic " + tokenPublic
	};
	fetch(`${timediaUrl}/keyvaluepublics/${cle}`, {
		headers: defaultHeaders,
		method: "GET"
	}).then(response => {
		if (response.status !== 200) {
			console.error("Error: " + response.status);
			return;
		}
		response.json().then(json => {
			const val = JSON.parse(json.data.valeur);
			console.log(val);
			callback(val);
		});
	});
};
